"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoModule = void 0;
class GoModule {
    constructor(name, version) {
        this.packages = [];
        this.name = name;
        this.version = version;
    }
    // fullName returns the module's name and version, separated with an `@`. This
    // reflects how Go stores them on disk (except for vendored paths).
    fullName() {
        return this.name + "@" + this.version;
    }
    snykNormalisedVersion() {
        // Versions in Go have leading 'v'
        let version = this.version.substring(1);
        // In versions with hash, we only care about hash
        // v0.0.0-20200905004654-be1d3432aa8f => #be1d3432aa8f
        version = version.includes("-")
            ? `#${version.substring(version.lastIndexOf("-") + 1)}`
            : version;
        return version;
    }
}
exports.GoModule = GoModule;
//# sourceMappingURL=go-module.js.map